import { Button, Snackbar } from "@mui/material";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import { useTenantTranslation } from "hooks/formatters";
import { useCallback, useState } from "react";
import { buildCsv, CsvColumnDef } from "src/utils/csv";

export const CopyWorkerStatsToClipboardButton = <T,>({
  rows,
  columns,
}: {
  rows: T[];
  columns: CsvColumnDef<T>[];
}) => {
  const { t } = useTenantTranslation();
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleCopy = useCallback(async () => {
    await navigator.clipboard.writeText(buildCsv(rows, columns));
    setSnackbarOpen(true);
  }, [rows, columns]);

  return (
    <>
      <Button
        variant="text"
        color="primary"
        onClick={() => void handleCopy()}
        startIcon={<FileCopyIcon />}
        sx={{ whiteSpace: "nowrap" }}
        disabled={rows.length === 0}
      >
        {t("copyToClipboard")}
      </Button>
      <Snackbar
        open={snackbarOpen}
        onClose={() => {
          setSnackbarOpen(false);
        }}
        autoHideDuration={2000}
        message={t("copiedToClipboard")}
      />
    </>
  );
};
